// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"efd4f134aaaec8ae0a45","655":"2647b3c9da4b8617ffca"}[chunkId] + ".js";
};